import { render } from "./VideoGroup.vue?vue&type=template&id=2add6a10&scoped=true"
import script from "./VideoGroup.vue?vue&type=script&lang=js"
export * from "./VideoGroup.vue?vue&type=script&lang=js"

import "./VideoGroup.vue?vue&type=style&index=0&id=2add6a10&lang=less&scoped=true"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2add6a10"]])

export default __exports__